
export enum EApplicationController {
  fetch_application = "FETCH_APPLICATION", //Получение заявки
  fetch_all_applications = "FETCH_ALL_APPLICATIONS", //Получение всех заявок
  fetch_application_for_current = "FETCH_APPLICATION_FOR_CURRENT", //Получение заявки клиента
  fetch_all_applications_for_current_user = "FETCH_ALL_APPLICATIONS_FOR_CURRENT_USER", //Получение всех заявок клиента
  fetch_application_status_history = "FETCH_APPLICATION_STATUS_HISTORY", //Получение истории статусов заявки
  view_all_signature_by_application = "VIEW_ALL_SIGNATURE_BY_APPLICATION",//Просмотр подписаний в разрезе заявки
  create_application = "CREATE_APPLICATION", //Создание заявки
  update_application = "UPDATE_APPLICATION", // Изменение заявки
  delete_application = "DELETE_APPLICATION", //Удаление заявки(SoftDelete)
  reject_application = "REJECT_APPLICATION", // Отклонение заявки
  revision_application = "REVISION_APPLICATION",//Отправка заявки на доработку
  upload_application_documents = "UPLOAD_APPLICATION_DOCUMENTS", //Загрузка документов для заявки
  delete_application_document = "DELETE_APPLICATION_DOCUMENT", //Удаление документа из заявки
  download_document = "DOWNLOAD_DOCUMENT", //Скачивание документа
}

export enum EApplicationAvailableActions {
  create_application_confirmation="CREATE_APPLICATION_CONFIRMATION",//Создание подтверждения заявки
  cm_approved_application ="CM_APPROVED_APPLICATION",//Подтвердить заявку кредитным менеджером
  lawyer_approved_application = "LAWYER_APPROVED_APPLICATION",//Подтвердить заявку юристом
  revision_by_cm = "REVISION_BY_CM", //Доработка кредитным менеджером
}

export enum EDecisionController {
  create_approval_decision = "CREATE_APPROVAL_DECISION",//Создать решения на выдачу кредита
  create_sign_decision = "CREATE_SIGN_DECISION", //Создание рещения
  cm_sign_decision = "CM_SIGN_DECISION", //Подпись решения кредитным менеджером
  lawyer_sign_decision = "LAWYER_SIGN_DECISION", //Подпись решения юристом
  revision_by_cm = "REVISION_BY_CM", //Доработка кредитным менеджером
}
export enum EDecisionAvailableActions {
  create_sign_decision = "CREATE_SIGN_DECISION", //Создание рещения
  cm_sign_decision = "CM_SIGN_DECISION", //Подпись решения кредитным менеджером
  lawyer_sign_decision = "LAWYER_SIGN_DECISION", //Подпись решения юристом
  revision_by_cm = "REVISION_BY_CM", //Доработка кредитным менеджером
}
export enum EContractController {
  fetch_contract = "FETCH_CONTRACT", //Просмотр договора
  fetch_all_contracts = "FETCH_ALL_CONTRACTS", // Просмотр всех контрактов
  fetch_all_contracts_for_current_user = "FETCH_ALL_CONTRACTS_FOR_CURRENT_USER", // Просмотр всех контрактов в разрезе пользователя
  client_sign_contract = "CLIENT_SIGN_CONTRACT", //Подпись котракта клиентом
  director_sign_contract = "DIRECTOR_SIGN_CONTRACT", //Подпись котракта директором
  contract_revoke = "CONTRACT_REVOKE", //Аннулирование договора
}
export enum EContractAvailableActions {
  client_sign_contract = "CLIENT_SIGN_CONTRACT", //Подпись котракта клиентом
  director_sign_contract = "DIRECTOR_SIGN_CONTRACT", //Подпись котракта директором
  contract_revoke = "CONTRACT_REVOKE", //Аннулирование договора
}
export enum ENoticeController {
  fetch_all_notice = "FETCH_ALL_NOTICE", //Получение всех уведомлений
  fetch_notice = "FETCH_NOTICE", //Получение уведомления
  fetch_all_notice_for_current_user = "FETCH_ALL_NOTICE_FOR_CURRENT_USER", //Получение всех уведомлений клиента'
  fetch_notice_for_current = "FETCH_NOTICE_FOR_CURRENT", //Получение уведомлений для текущего пользователя
  fetch_notice_status_history = "FETCH_NOTICE_STATUS_HISTORY", //Получение истории статусов уведомления
  fetch_notice_attachments = "FETCH_NOTICE_ATTACHMENTS", //Получение АВР/Накладных уведомления
  create_notice = "CREATE_NOTICE", //Создание уведомления
  create_notice_document = "CREATE_NOTICE_DOCUMENT", //Создание документа уведомления
  revision_notice = "REVISION_NOTICE", //Отправка уведомления на доработку

  fetch_all_registry = "FETCH_ALL_REGISTRY", //Получение всех реестров
  fetch_registry = "FETCH_REGISTRY", //Получение реестра
  fetch_all_registry_for_current_user = "FETCH_ALL_REGISTRY_FOR_CURRENT_USER", //Получение всех реестров клиента'
  fetch_registry_for_current = "FETCH_REGISTRY_FOR_CURRENT", //Получение реестров для текущего пользователя
  fetch_registry_status_history = "FETCH_REGISTRY_STATUS_HISTORY", //Получение истории статусов реестров
  fetch_registry_attachments = "FETCH_REGISTRY_ATTACHMENTS", //Получение АВР/Накладных реестров
  create_registry = "CREATE_REGISTRY", //Создание реестров
  create_registry_document = "CREATE_REGISTRY_DOCUMENT", //Создание документа реестров
  revision_registry = "REVISION_REGISTRY", //Отправка реестров на доработку
}
export enum ENoticeAvailableActions {
  send_notice_to_sign = "SEND_NOTICE_TO_SIGN", //Отправить уведомления на подпись,
  client_sign_notice = "CLIENT_SIGN_NOTICE", //Подпись уведомления клиентом
  director_sign_notice = "DIRECTOR_SIGN_NOTICE",//Подпись уведомления директором
  send_registry_to_sign = "SEND_REGISTRY_TO_SIGN", //Отправить акт приема-передачи документов на подпись,
  client_sign_registry = "CLIENT_SIGN_REGISTRY", //Подпись акт приема-передачи документов клиентом
  revision_by_cm = "REVISION_BY_CM", //Доработка кредитным менеджером
}

export enum EDisbursementController {
  create_disbursement = "CREATE_DISBURSEMENT", //Создание выдачи
}
export enum EAdditionalContractController {
  create_additional_contract = "CREATE_ADDITIONAL_CONTRACT",//Создание доп контракта
  update_additional_contract = "UPDATE_ADDITIONAL_CONTRACT",//Обновдение доп контракта
}
export enum EAdditionalContractAvailableActions{
  create_additional_contract = "CREATE_ADDITIONAL_CONTRACT",//Создание доп контракта км-ом
  cm_sign="CM_SIGN",//Подписание кредитным менеджером
  lawyer_sign = "LAWYER_SIGN", //Подписание доп контракта юристом
  client_sign = "CLIENT_SIGN",//Подписание доп контракта клиентом
  director_sign = "DIRECTOR_SIGN",//Подписание до контракта директором
  revision_by_cm = "REVISION_BY_CM", //Доработка кредитным менеджером
  reject_additional_contract = "REJECT_ADDITIONAL_CONTRACT", //Отклонение доп контракта
}

export enum ESignatureController {
  sign_consent = "SIGN_CONSENT", // Подписание согласия
  load_consent = "LOAD_CONSENT", // Загрузка согласий
  assign_consent = "ASSIGN_CONSENT", // Отпрвить согласия на подписания
}

export enum ESignatureAvailableAction {
  sign_consent = "SIGN_CONSENT", // Подписание согласия
  load_consent = "LOAD_CONSENT", // Загрузка согласий
  assign_consent = "ASSIGN_CONSENT", // Отпрвить согласия на подписания
}

export enum EClientController {
  fetch_client = "FETCH_CLIENT", //Редактирование клиента
  fetch_all_clients = "FETCH_ALL_CLIENTS", //Получение всех клиентов
  fetch_role_list = "FETCH_ROLE_LIST", //Получение списка ролей
  create_client = "CREATE_CLIENT", //Создание клиента
  update_client = "UPDATE_CLIENT", //Редактирование клиента
  block_client = "BLOCK_CLIENT", //Удаление клиента
}

export enum EDictionaryController {
  fetch_application_status_list = "FETCH_APPLICATION_STATUS_LIST", // Получение статусов заявок
  fetch_day_category_list = "FETCH_DAY_CATEGORY_LIST", // Получение типов дней по отсрочке
  fetch_financing_limit_list = "FETCH_FINANCING_LIMIT_LIST", // Получение предельного размера финансирования
  fetch_factoring_type_list = "FETCH_FACTORING_TYPE_LIST", // Получение типов факторинга
  fetch_document_type_list = "FETCH_DOCUMENT_TYPE_LIST", // Получение типов документов
}

export enum EDocumentController {
  upload_document = "UPLOAD_DOCUMENT", //Загрузка документа
}

export enum EEmployeeController {
  fetch_employee = "FETCH_EMPLOYEE", // Получение сотрудника
  fetch_all_employees = "FETCH_ALL_EMPLOYEES", // Получение всех сотрудников
  fetch_role_list = "FETCH_ROLE_LIST", // Получение списка ролей
  create_employee = "CREATE_EMPLOYEE", // Создание сотрудника
  update_employee = "UPDATE_EMPLOYEE", // Обновление информации о сотруднике
  delete_employee = "BLOCK_EMPLOYEE", // Удаление сотрудника(Деактивация/Архивирование)
}

export enum EDebtorController {
  fetch_debtor= "FETCH_DEBTOR", //Получение дебтора,
  fetch_all_debtor = "FETCH_ALL_DEBTOR", //Получение списка дебторов
  create_debtor = "CREATE_DEBTOR", //Создание дебтора
  update_debtor="UPDATE_DEBTOR",//Изменение дебтора
}

export enum ELeadApplicationContoller {
  fetch_lead_application = "FETCH_LEAD_APPLICATION", //Получение лида
  fetch_all_lead_application = "FETCH_ALL_LEAD_APPLICATION", //Получение списка лидов
  create_lead_application = "CREATE_LEAD_APPLICATION", //Создание лида
  update_lead_application = "UPDATE_LEAD_APPLICATION", //Изменение лида
}

export enum ETemplateParameterContoller {
  fetch_parameter_for_current="FETCH_TEMPLATE_PARAMETER_FOR_CURRENT",//Список переменных для организации
  update_template_parameter="UPDATE_TEMPLATE_PARAMETER"//Изменение переменной
}
export const ActionList = {
  applications: EApplicationController,
  clients: EClientController,
  dictionaries: EDictionaryController,
  documents: EDocumentController,
  decisions: EDecisionController,
  employees: EEmployeeController,
  signatures: ESignatureController,
  contracts: EContractController,
  notices: ENoticeController,
  disbursement: EDisbursementController,
  additioanlContract:EAdditionalContractController,
  debtors: EDebtorController,
  leads: ELeadApplicationContoller,
  templates:ETemplateParameterContoller,
};
export const AvailableActionList = {
  applications: EApplicationAvailableActions,
  decisions: EDecisionAvailableActions,
  contracts: EContractAvailableActions,
  notices: ENoticeAvailableActions,
  additionalContracts: EAdditionalContractAvailableActions,
  signatures: ESignatureAvailableAction
};
export type AvailableActions =
  & EApplicationAvailableActions
  & EDecisionAvailableActions
  & ENoticeAvailableActions
  & EContractAvailableActions
  & EAdditionalContractAvailableActions
  & ESignatureAvailableAction;

export type Actions =
  | EApplicationController
  | EClientController
  | EDictionaryController
  | EDocumentController
  | EEmployeeController
  | ESignatureController
  | EDecisionController
  | EContractController
  | ENoticeController
  | EDisbursementController
  | EAdditionalContractController
  | EDebtorController
  | ELeadApplicationContoller
  | ETemplateParameterContoller;
